import React, {useContext, useEffect, useState} from "react";
import {LoaderContext} from "../../../../context/LoaderContext";
import {
    convertiDateInDataPerDb,
} from "../../../../utility/common";
import ListDocumentiFirmatiView from "./ListDocumentiFirmatiView";
import {getDocumentiFirmatiApi, getTipiRichiestaCertificatiApi} from "../../../../services/CertificatiServices";

export default function ListDocumentiFirmatiController() {

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const [filtro, setFiltro] = useState({
        targa: '',
        nominativo: '',
        marca: '',
        tipo: '',
        id_tipo_certificato: '',
        data_registrazione_da: '',
        data_registrazione_a: '',
    });

    const [loadingData, setLoadingData] = useState(true);
    const [pagina, setPagina] = useState(1);
    const [totPagine, setTotPagine] = useState();
    const [documentiFirmati, setDocumentiFirmati] = useState([]);
    const [tipiCertificato, setTipiCertificato] = useState([]);
    const [totDocumentiFirmati, setTotDocumentiFirmati] = useState(0);

    function initFiltro() {
        setFiltro({
            targa: '',
            nominativo: '',
            marca: '',
            tipo: '',
            id_tipo_certificato: '',
            data_registrazione_da: '',
            data_registrazione_a: '',
        });
    }

    function getFiltriCertificati() {
        let f = {
            pag: pagina
        };

        if (filtro.nominativo && filtro.nominativo !== '') {
            f.nominativo = filtro.nominativo;
        }
        if (filtro.targa && filtro.targa !== '') {
            f.targa = filtro.targa;
        }
        if (filtro.marca && filtro.marca !== '') {
            f.marca = filtro.marca;
        }
        if (filtro.tipo && filtro.tipo !== '') {
            f.tipo = filtro.tipo;
        }
        if (filtro.id_tipo_certificato && filtro.id_tipo_certificato !== '') {
            f.id_tipo_certificato = filtro.id_tipo_certificato;
        }
        if (filtro.data_pagamento_da && filtro.data_pagamento_da !== '') {
            f.data_pagamento_da = convertiDateInDataPerDb(filtro.data_pagamento_da);
        }
        if (filtro.data_pagamento_a && filtro.data_pagamento_a !== '') {
            f.data_pagamento_a = convertiDateInDataPerDb(filtro.data_pagamento_a);
        }
        if (filtro.data_registrazione_da && filtro.data_registrazione_da !== '') {
            f.data_registrazione_da = convertiDateInDataPerDb(filtro.data_registrazione_da);
        }
        if (filtro.data_registrazione_a && filtro.data_registrazione_a !== '') {
            f.data_registrazione_a = convertiDateInDataPerDb(filtro.data_registrazione_a);
        }
        return f;
    }

    async function getDocumentiFirmati() {
        let f = getFiltriCertificati();

        startChiamata();

        const response = await getDocumentiFirmatiApi(f);
        setDocumentiFirmati(response.data.data);
        setTotPagine(response.data.pages);
        setTotDocumentiFirmati(response.data.tot);
        setLoadingData(false);
        endChiamata();
    }

    async function getTipiCertificato() {
        startChiamata();

        const response = await getTipiRichiestaCertificatiApi();
        setTipiCertificato(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        getDocumentiFirmati();
        getTipiCertificato();
    }, [pagina]);

    const cambioPagina = (nuovaPagina) => {
        setPagina(nuovaPagina)
    }

    return (
        <ListDocumentiFirmatiView
            totPagine={totPagine}
            filtro={filtro}
            setFiltro={setFiltro}
            cambioPagina={cambioPagina}
            getDocumentiFirmati={getDocumentiFirmati}
            documentiFirmati={documentiFirmati}
            totDocumentiFirmati={totDocumentiFirmati}
            initFiltro={initFiltro}
            loadingData={loadingData}
            pagina={pagina}
            tipiCertificato={tipiCertificato}
            handlerUpdateCertificati={() => {
                getDocumentiFirmati();
            }}
        />
    );
}